import { connect } from 'react-redux'
import EditTitleDialog from './edit-title-dialog'

import {
  editTitle,
  closeEditTitleDialog
} from '../../../stores/assessment-file/assessment-file.actions'
import { getEditTitleDialog } from '../../../stores/assessment-file/assessment-file.selectors'

const mapStateToProps = state => {
  const dialog = getEditTitleDialog(state)
  return {
    isOpen: dialog.opened,
    id: dialog.id,
    title: dialog.title,
    description: dialog.description,
    moderation_type: dialog.moderation_type,
    judgement: dialog.judgement,
    pending: false
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onClose: () => dispatch(closeEditTitleDialog()),
  onUpdate: (
    editedTitle,
    editedDescription,
    editedModerationType,
    editedJudgement
  ) =>
    dispatch(
      editTitle(
        stateProps.id,
        editedTitle,
        editedDescription,
        editedModerationType,
        editedJudgement
      )
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(EditTitleDialog)
